//#region react import
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//#endregion

//#region component import
import DocumentationModalContent from "../DocumentationModalContent/DocumentationModalContent.component.jsx";
import GstaModal from "../GstaModal/GstaModal.component.jsx";
//#endregion

//#region function import
import { createDocumentationObject } from "../../Helper/HandleDocumentation.js";
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region service import
import { getJsonContent } from "../../Services/PatchNotesService.js";
//#endregion

//#region constants import
import { ICON_UNKNOWN_DOCUMENT } from "../../Constants/IconConstants.js";
import { TRANSLATIONS } from "../../Constants/Translations.js";
//#endregion

//#region import style
import { CLOUD_DOCUMENTATION_JSON_FILE, DOCUMENTATION_JSON_FILE } from "../../Constants/Documentation.js";
import "./DocumentationModal.style.scss";
//#endregion

const DocumentationModal = () => {
  //#region redux store
  const translations = useSelector((state) => state.translationSlice.translations);
  const language = useSelector((state) => state.translationSlice.language);
  const machines = useSelector((state) => state.machineSlice.machines);
  const dispatch = useDispatch();
  //#endregion

  //#region state
  const [modalOpen, setModalOpen] = useState(false);
  //#endregion

  //#region functions
  const buildDocumentationTree = async () => {
    let jsonContent;

    if (process.env.REACT_APP_LOCAL || process.env.NODE_ENV === "development") {
      await fetch("/createDocumentationTree").then(async (response) => {
        if (response.ok) {
          jsonContent = await getJsonContent(DOCUMENTATION_JSON_FILE);
        }
      });
    } else {
      await fetch("/createDocumentationTreeCloud").then(async (response) => {
        if (response.ok) {
          jsonContent = await getJsonContent(CLOUD_DOCUMENTATION_JSON_FILE);
        }
      });
    }
    createDocumentationObject(jsonContent, language, machines, dispatch);

    setModalOpen(true);
  };
  //#endregion

  return (
    <div className="gsta-documentation">
      <i
        className={`${ICON_UNKNOWN_DOCUMENT}`}
        onClick={buildDocumentationTree}
      />
      {modalOpen && (
        <GstaModal
          modalOpen={modalOpen}
          title={getTranslations(TRANSLATIONS.DOCUMENTATION, translations)}
          cancelText={getTranslations(TRANSLATIONS.COMMON_CANCEL, translations)}
          handleCloseModal={() => setModalOpen(false)}
          className={"documentation-modal"}
        >
          <DocumentationModalContent />
        </GstaModal>
      )}
    </div>
  );
};
export default DocumentationModal;
